module.exports = __webpack_public_path__ + "media/images/admin/auction_hammer-5f962edcf5bac8aa0fd1a61393923d08.png";